import { lazy } from 'react';
import { Redirect } from 'react-router-dom';
// layouts
import HomeLayout from '../layouts/home';

// ----------------------------------------------------------------------

const HomeRoutes = {
  path: '*',
  layout: HomeLayout,
  routes: [
    {
      exact: true,
      path: '/successful',
      component: lazy(() => import('../views/SubmissionSuccessful'))
    },

    {
      exact: true,
      path: '/expired',
      component: lazy(() => import('../views/ExpiredForm'))
    },

    {
      exact: true,
      path: '/:questionnaire',
      component: lazy(() => import('../views/LandingPage'))
    },

    // ----------------------------------------------------------------------

    {
      component: () => <Redirect to="/404" />
    }
  ]
};

export default HomeRoutes;
